import { RouterProvider } from 'react-router';
import { useEffect, useState } from 'react';

import { AppProviders } from './providers';
import { registerServiceWorker } from './pwa';
import { createRouter } from './router';
import { documentTitle } from './title';

/**
 * The application root — providers outside the router, so the session and the query cache survive
 * every navigation (T007).
 */
export function App() {
  const [router] = useState(createRouter);

  // The build already substituted this into `index.html`; setting it again from the same catalogue
  // value keeps the tab correct however the document arrived — including a back/forward restore or
  // a copy the browser's own HTTP cache held from before a catalogue change. Nothing here involves
  // the service worker: T073 caches no application shell, so a stale `index.html` is not a state
  // this product can be in.
  useEffect(() => {
    document.title = documentTitle();
  }, []);

  // T073: the installable shell registers its worker once the application is on screen. It is
  // fire-and-forget on purpose — the worker only adds installability and an offline fallback page,
  // so nothing here waits for it and no outcome of it is ever rendered.
  useEffect(() => {
    void registerServiceWorker();
  }, []);

  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
